// src/oura/components/visibility/rowFocus.ts
//
// Where focus goes when a drawer opened from a row closes. A table row opened
// by pointer is not a control and never held focus, so the drawer is told
// which control to return to: the row's own button, found again after the
// close has re-rendered the list.

/** The first visible control among the matches: focus sent to a hidden one goes nowhere. */
function visibleControl(selector: string): HTMLElement | null {
    return Array.from(document.querySelectorAll<HTMLElement>(selector)).find((el) => el.getClientRects().length > 0) ?? null;
}

/** A question row's control. The table and the stacked rows are both in the page, one hidden. */
export function questionRowControl(id: number): HTMLElement | null {
    return visibleControl(`[data-q-row="${id}"] button`);
}

/** A source row's control. */
export function sourceRowControl(domain: string): HTMLElement | null {
    return visibleControl(`[data-source-row="${CSS.escape(domain)}"] button`);
}
